import React, { useMemo } from 'react';

import {
  Text, Tooltip, Flex, TextProps,
} from '@chakra-ui/react';

import { Icon } from 'components/icon';

interface LabelProps extends TextProps {
  isRequired?: boolean
  isDisabled: boolean
  label: string
  tooltip?: string
}
export default function Label({
  isDisabled,
  isRequired,
  label,
  tooltip,
  ...rest
}: LabelProps) {
  const disabledColor = useMemo(() => (isDisabled ? 'gray.400' : 'gray.600'), [isDisabled]);
  return (
    <Tooltip
      placement="top"
      hasArrow
      label={tooltip}>
      <Flex
        mb={1}
        alignItems="center"
        w="fit-content"
        {...rest}>
        <Text
          mr={1}
          color={disabledColor}
          variant="smallSemiBold">
          {isRequired ? `${label} *` : label}
        </Text>
        {!!tooltip && (
          <Icon
            size="md"
            name="question-circle"
            family="fas"
            color={disabledColor}
          />
        )}
      </Flex>
    </Tooltip>
  );
}
